/**
 * @todo investigate getting types from swagger:
 * - https://dev.to/pavelkeyzik/generate-typescript-types-from-swagger-openapi-3-amh
 * - https://github.com/mtennoe/swagger-typescript-codegen
 */
export type Audit = {
  auditID: number
  auditNumber: string
  preparationDate: string
  reportDate: string
  legalStatusVersion: string
  auditors: string
  companyID: number
  company: {
    companyID: number
    name: string
    companyHeadquaters: string
  }
  auditParticipants: string
  introductionLeft: string
  introductionRight: string
  summary: string
  localization: string
  activities: string
  assessmentScope: string
  excelURL: string
  auditCompleted: boolean
  additionalInformation: string
  auditRequirements: AuditRequirement[]
}

export type Location = {
  companyID: number
  name: string
  companyHeadquaters: string
  notConfigured?: boolean
  ongoingAuditId?: number | null
  requirementsBaseIds: number[]
  tableData?: any
}

export type LocationAudits = {
  lastActiveAuditID: number
  lastClosedAuditID: number

  lastClosedAuditLocalization: string
  lastActiveAuditLocalization: string
}

export type LocationDecorated = Location &
  LocationAudits & {
    action: string | string[]
  }

export type LegalBasisType = {
  legalBasisTypeID: string
  name: string
}

export type LegalBasis = {
  details: string
  paragraph: string
  documentName: string
  legalBasisID: number
  legalBasisType: LegalBasisType
  lexApiNRO: string
  lexApiURL: string
}

export type Act = {
  documentName: string | null
  details: string
  lexApiURL: string | null
}

export type Newsletter = {
  id: number
  externalId: string
  type: string
  moduleId: string
  userId: string
  createdAt: string
  updatedAt: string
  updatedById: string
  newsletterDateId: string
  status: string
  scopeId: number
  fileUrl: string | null
  blobName: string | null
  fileName: string | null
  title?: string
}

export type AuditRequirementImage = {
  imageID: number | string
  imageURL: string
  fileName: string
  auditID: number
  auditRequirementID: number
}

export type BaseRequirementLegalBasis = {
  legalBasis: LegalBasis
  legalBasisId: number
  paragraph: string
}

export type RequirementForm = {
  title: string
  lexUrl: string
}

export type BaseRequirement = {
  requirementBaseID: number
  group: RequirementDefaultGroup
  name: string
  description: string
  tooltipData: string
  fixDate: string
  order: number
  isPublished: boolean
  deprecated: boolean
  default: false
  legalBasis: BaseRequirementLegalBasis[]
}

export type BaseRequirementGroupedByScopes = {
  imageURL: string
  id: number
  name: string
  order: number
  groupedRequirementBases: {
    id: number
    scopeId: number
    name: string
    order: number
    baseRequirements: {
      id: number
      name: string
      order: number
    }[]
  }[]
}

export type FormattedBaseRequirementGroupedByScopes = {
  scope: { scopeID: number; name: string }
  groupID: number
  name: string
  requirements: {
    requirementBaseID: number
    groupID: number
    name: string
    group: { groupID: number; name: String }
  }[]
}[]

interface IColorsPropertiesObject {
  auditor: string
  client: string
}

interface IColorsPropertiesObject {
  auditor: string
  client: string
}

export type AuditRequirement = {
  summary: string
  auditRequirementID: number
  auditID: number
  groupID: number
  scopeID: number
  name: string
  description: string
  fixDate: string
  evaluationDate: string
  legalBasisParagraph: string
  auditorAssessment: string
  requirementBaseID: number
  isOutdated: boolean
  images: AuditRequirementImage[]
  auditorStatus?: RequirementStatus
  clientStatus?: RequirementStatus
  legalBasis: LegalBasis[]
  tooltipData: string
  group: RequirementsGroup<any>
  connectedAuditRequirements: number[]
  colors: IColorsPropertiesObject
  isDraft: boolean
  connectedAspects: number[]
  connectedDecisions: number[]
  connectedDocuments: number[]
  alertExpirationDate?: string
}

export type AuditRequirementEnhanced = AuditRequirement & {
  group: RequirementDefaultGroup
  scope: Scope
}

export type AuditRequirements = AuditRequirement[]

export type TableData = {
  tableData?: { id: number }
}

export type RequirementType = AuditRequirement | BaseRequirement

export type RequirementsGroup<Requirement> = {
  groupID: number
  name: string
  scope: Scope
  requirements: Requirement[]
  no?: number
}

export type RequirementStatus = {
  statusID: number
  statusBaseID: number
  comment?: string
}

export type RequirementDefaultGroup = {
  groupID: number
  scope: Scope
  name: string
  order: number
}

export type RequirementDefaultGroups = RequirementDefaultGroup[]

export enum StatusTypes {
  Accepted = 'Accepted',
  Warnings = 'Warnings',
  Infringement = 'Infringement',
  Rejected = 'Rejected',
  NotAssessed = 'NotAssessed',
  NotApplicable = 'NotApplicable',
  NoShow = 'NoShow',
  New = 'New',
  /**
   * This is special type only for FE purposes, used to show negative color of parent status
   */
  NotAssessedNegative = 'NotAssessedNegative',
}

export type Status = {
  statusID: number
  name: string
  order: number
  label: StatusTypes
}

export type SummaryTemplate = {
  descriptionTemplateID: number
  description: string
  summaryTemplateID: number
}

export type Template = {
  descriptionTemplateID: number
  description: string
  status: Status
  requirementBase: BaseRequirement
  summaryTemplates: SummaryTemplate[]
}

export enum Roles {
  Admin = 'Administrator EcoMS',
  Auditor = 'Audytor',
  Client = 'Rozszerzony',
  ClientEditor = 'Specjalista',
  ClientBasic = 'Podstawowy',
  ClientAdministrator = 'Administrator',
}

export type UserPassword = {
  password: string
}

export type Role = {
  roleID: string
  roleName: Roles
}

export type User = {
  email: string
  userID: string
  userRoles: Role[]
  companies: Location[]
  name?: string
  surname?: string
  isNotYetLoggedIn: boolean
}

export type NewsletterExternalModule = {
  id: string
  fullName: string
  shortcut: string
}

export type Scope = {
  name: string
  scopeID: number
  imageURL: string
  groups: RequirementsGroup<AuditRequirement>[]
  newsletterExternalModules: NewsletterExternalModule[]
}

export type ConfigScope = {
  companyId: number
  auditScopes: { isActive: boolean; scopeId: number }[]
  baseRequirementsIds?: number[] | null
  scopedRequirements: GroupEvaluationProfile[]
}

export type HistoryDocument = {
  name: string
  creationDate: string
}

export type Aspect = {
  id: number
  name: string
  companyId: number
  isSignificant: boolean
  requirementId: number | null
}

export type Decision = {
  id: number
  name: string
  companyId: number
  fileName?: string
}

export type Document = {
  id: number
  name: string
  companyId: number
  fileName?: string
}

export type SharedFile = {
  id: number
  name: string
  fileName?: string
}

export type AutocompleteValue = Record<string, string>

export enum AdminResourceType {
  USERS = 'users',
  COMPANIES = 'companies',
  ROLES = 'roles',
  SCOPES = 'scopes',
  GROUPS = 'groups',
  STATUSES = 'statuses',
  TEMPLATES = 'templates',
  REQUIREMENTS = 'requirements',
  LEGAL_BASIS = 'legalbasis',
  LEGAL_BASIS_TYPE = 'legalbasistype',
  SUMMARY_TEMPLATES = 'summaryTemplates',
}

export const CLIENT_ADMIN = 'clientAdmin'
export enum ClientAdminResourceType {
  USERS = `${CLIENT_ADMIN}.users`,
}

export enum StatusKeyTypes {
  CLIENT_STATUS = 'clientStatus',
  AUDITOR_STATUS = 'auditorStatus',
}

export type GenericResourceData = Record<string, unknown>[]

export type LexSearchResultType = {
  documentMainType: string
  documentType: string
  nro: number
  signature: string
  title: string
  version: number
}

export type LexSearchType = {
  allDocumentCount: number
  deprecated: boolean
  results: LexSearchResultType[]
  size: number
}

export type RequirementStatusEvaluationProfile = {
  comment: string | null
  statusBaseId: number
}

export type RequirementEvaluationProfileBase = {
  id: number
  name: string
  order: number
  description: string
  scopeId: number
  groupId: number
}

export enum AlertAcceptanceStatus {
  NotAccepted = 0,
  Accepted = 1,
}

export enum AlertTriggeredBy {
  AddingNewRequirementBase = 0,
  ModifyingExistingRequirementBase = 1,
}

export type RequirementEvaluationProfileAlert = {
  acceptanceStatus: AlertAcceptanceStatus
  triggeredBy: AlertTriggeredBy
}

export type RequirementEvaluationProfile = RequirementEvaluationProfileBase & {
  isDraft?: boolean | null
  isOutdated?: boolean | null
  auditorStatus?: RequirementStatusEvaluationProfile | null
  clientStatus?: RequirementStatusEvaluationProfile | null
  auditorAssessment?: string | null
  alert: RequirementEvaluationProfileAlert | null
}

export type GroupEvaluationProfile = {
  id: number
  name: string
  order: number
  requirements: RequirementEvaluationProfile[]
  scopeId: number
}

export type ScopeEvaluationProfile = {
  id: number
  name: string
  order: number
  groups: GroupEvaluationProfile[]
}

export type CompanyProfile = {
  companyID: number
  ongoingAuditId: number | null
  notConfigured: boolean
  scopesUnderAssessment: number[]
  name: string
  companyHeadquaters: string
  scopesInEsqula: ScopeEvaluationProfile[]
  assessedScopes: ScopeEvaluationProfile[]
}

export type AuditResponse = {
  auditId: number
  companyName: string | null
  auditNumber: string | null
  preparationDate: string | null
  reportDate: string | null
  legalStatusVersion: string | null
  auditors: string | null
  auditParticipants: string | null
  introductionLeft: string | null
  introductionRight: string | null
  localization: string | null
  activities: string | null
  summary: string | null
  auditCompleted: boolean
  auditCompletedDate: string | null
  additionalInformation: string | null
  scopedRequirements: ScopeEvaluationProfile[] | null
  isReadyToPublish: boolean | null
}

export type AuditMetrics = {
  auditNumber: string
  preparationDate: string
  reportDate: string
  legalStatusVersion: string
  auditors: string
  auditParticipants: string
  introductionLeft: string
  localization: string
  activities: string
  summary: string
  additionalInformation: string
}

export type CompanyMetrics = {
  scopeId: number
  scopeName: string
  isAudit: boolean
  auditMetrics: AuditMetrics
}[]

export type RequirementPhoto = {
  imageID: string
  imageURL: string
  fileName: string
}

export type ConnectedAuditRequirement = {
  id: number
  name: string
}

export type AuditRequirementResponse = {
  scopeName: string | null
  groupName: string | null
  fixDate: string | null
  evaluationDate: string | null
  tooltipData: string | null
  connectedAuditRequirements: ConnectedAuditRequirement[] | null
  connectedAspects: number[] | null
  connectedDecisions: number[] | null
  connectedDocuments: number[] | null
  images: RequirementPhoto[] | null
  legalBasis: LegalBasis[] | null
  isOutdated: boolean | null
  isDraft: boolean | null
  auditorAssessment: string | null
  auditorStatus: RequirementStatusEvaluationProfile | null
  clientStatus: RequirementStatusEvaluationProfile | null
  id: number | null
  name: string | null
  description: string | null
  order: number | null
  scopeId: number | null
  groupId: number | null
  summary: string | null
  requirementBaseId: number | null
  forms: { title: string; lexUrl: string }[] | null
}

export interface RequirementFormConfigField {
  show: boolean
  editable: boolean
  defaultValue: any
  saveAsKey?: string
}

export type RequirementFormConfigFieldKeys =
  | 'auditorStatusID'
  | 'clientStatusID'
  | 'connectedDocuments'
  | 'connectedDecisions'
  | 'connectedAspects'
  | 'clientComment'
  | 'auditorAssessment'
  | 'summary'
  | 'connectedAuditRequirements'
  | 'fixDate'
  | 'photos'
  | 'evaluationDate'

export interface RequirementFormConfig {
  fields: Partial<
    Record<RequirementFormConfigFieldKeys, RequirementFormConfigField>
  >
  allowSave: boolean
  allowDraft: boolean
  allowTemplates: boolean
  prevUrl: string
  invalidateQueriesUrl: string
  endpointType: RequirementEndpointType
  auditID?: string | null
  requirementID?: number | null
  requirementBaseID?: number | null
}

export type RequirementAssesmentPayload = Partial<{
  auditorAssessment: string
  status: number
  statusComments: string | null
  fixDate: string
  summary: string
  connectedAuditRequirements: number[]
  connectedAspects: number[]
  connectedDecisions: number[]
  connectedDocuments: number[]
  [key: string]: any
}>

export type RequirementEndpointType =
  | 'client'
  | 'auditor'
  | 'correction'
  | 'esqulaClient'
  | 'esqulaCorrection'

export type RequirementPageType = 'published' | 'esqula' | 'assessment'

export type RequirementGroup = {
  groupID: number
  name: string
  scope: Scope
  order: number
}

export type RequirementAlert = {
  id: number | null
  expirationDate: string | null
} | null
